export default "__VITE_ASSET__020d6d23__"